function isValidUrl(url: string): boolean {
  try {
    new URL(url); // Try creating a URL object. If it fails, the URL is invalid.
    return true;
  } catch (_) {
    return false;
  }
}

export default isValidUrl;
